const translations = {
    title: 'Reset Password',
    description: '',
    canonical: 'string',
    image: '',
    robots: 'noindex, nofollow',
};

export default translations;